export enum Sizes {
  OneThird = 'one-third',
  Half = 'half',
  TwoThirds = 'two-thirds',
  Full = 'full',
}

export enum Layout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
